import { Component, OnInit, Inject } from '@angular/core';
import { VisaTypes } from '../../models/VisaTypes';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { UserService } from '../../service/user.service';
import { EmployeeService } from '../../service/employee.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { OnboardingService } from '../../service/onboarding.service';

@Component({
  selector: 'app-visa-dialog',
  templateUrl: './visa-dialog.component.html',
  styleUrls: ['./visa-dialog.component.css']
})
export class VisaDialogComponent implements OnInit {
  title: string;
  message: any;
  visaType: VisaTypes;
  error: any;
  empCode: number;
  VisaForm: FormGroup;
  visaTypesList: any[];
  visabool: Boolean = false;
  constructor(private toastr: ToastrService, private userService: UserService, public dialogRef: MatDialogRef<VisaDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: VisaDialog, private _service: EmployeeService, private formBuilder: FormBuilder, private onboardSvc: OnboardingService) {
    dialogRef.disableClose = true;
    // Update view with given values
    this.title = data.title;
    this.message = data.message;
  }
  ngOnInit() {
    this.visaType = new VisaTypes();
    this.getVisaTypes();
    this.empCode = this.userService.getEmpCode();
    const nonWhitespaceRegExp: RegExp = new RegExp("\\S");
    this.VisaForm = this.formBuilder.group({
      VisaName: ['', [Validators.required, Validators.pattern(nonWhitespaceRegExp)]],
    });
  }
  getVisaTypes() {
    if (this.data.parentName == 'app-hr-employee-details') {
      this._service.getVisaTypes().subscribe(
        (data: any) => {
          this.visaTypesList = data;
        });
    }
    else {
      this.onboardSvc.getVisaTypes().subscribe(
        (data: any) => {
          this.visaTypesList = data;
        });
    }
  }

  get f() { return this.VisaForm.controls; }
  onConfirm(): void {
    if (!this.VisaForm.invalid) {
      this.visaType.ModifiedBy = this.empCode.toString();
      this.visaTypesList.forEach(item => {

        if (item.toLowerCase() == this.visaType.VisaName.toLowerCase()) {
          this.visabool = true;
        }


      });
      if (this.visabool == false) {
        this._service.SaveVisaType(this.visaType).subscribe(data => {
          this.dialogRef.close(this.visaType)
        }, error => this.error = error)
      }
      else {
        this.toastr.warning("Same visa exists");
        this.visaType.VisaName = null;
        this.visabool = false;
      }

    }
    else {
      return;
    }


  }
  onDismiss(): void {
    // Close the dialog, return false
    this.dialogRef.close(false);
  }
}
export class VisaDialog {

  constructor(public title: string, public message: any,public parentName : string) {
  }

}
